import { ModuleLink } from "components/common/moduleNavigation/moduleTypes/moduleTypes";
import grid4x4 from "assets/images/moduleNavigationIcons/grid4x4.svg";
import { Dashboard } from "routes/manufacturingNew/Dashboard";

export const upholsteryOrders: ModuleLink = {
  url: "upholstery-orders",
  label: "Zlecenia tapicerskie",
  icon: grid4x4,
  subSection: <></>,
  routing: Dashboard,
  isAccessible: false,
};
